(() => {
  'use strict';
  if (window.AMCUprightHingeInstalled) return;
  window.AMCUprightHingeInstalled = true;
  const validate = (event, form) => {
    const hinge = form?.querySelector('[data-amc-upright-hinge]');
    if (!hinge || hinge.value) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    hinge.setAttribute('aria-invalid', 'true');
    hinge.setCustomValidity('Choose a door hinge before adding this cooler to the cart.');
    hinge.reportValidity();
    hinge.focus();
  };
  document.addEventListener('submit', event => validate(event, event.target), true);
  document.addEventListener('click', event => {
    const button = event.target.closest?.('button[type="submit"],input[type="submit"]');
    if (button) validate(event, button.form);
  }, true);
  document.addEventListener('change', event => {
    if (!event.target.matches?.('[data-amc-upright-hinge]')) return;
    event.target.setCustomValidity('');
    event.target.setAttribute('aria-invalid', String(!event.target.value));
  });
})();
